export default "__VITE_ASSET__054e286c__"